/* ============================================================
   Maison Sillage · cart-payload
   Pure functie die een klant-selectie vertaalt naar de body
   voor Shopify's /cart/add.js. Geen DOM, geen fetch — puur data,
   zodat 'ie los te unit-testen is (zie tests/cart-payload.test.js).

   Contract (spec #1):
     selection = {
       type: "pre-worn" | "mto",
       variantId: number,
       addons: number[],                       // variant-ID's van add-on-producten
       mto?: { verkoopster, draagtijd, kledingstuk }     // made-to-order keuzes -> line item properties
     }
     buildCartPayload(selection) -> { items: [ { id, quantity, properties? } ] }
   ============================================================ */
(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) { module.exports = api; }
  if (root) { root.OS = root.OS || {}; root.OS.buildCartPayload = api.buildCartPayload; }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  // Normaliseer een variant-ID naar een positief geheel getal, of null als ongeldig.
  function toId(v) {
    if (typeof v === "number" && isFinite(v) && v > 0) return Math.trunc(v);
    if (typeof v === "string" && v.trim() !== "" && !isNaN(Number(v)) && Number(v) > 0) {
      return parseInt(v, 10);
    }
    return null;
  }

  function buildCartPayload(selection) {
    if (!selection || typeof selection !== "object") return { items: [] };

    var variantId = toId(selection.variantId);
    if (variantId == null) return { items: [] };   // ongeldig hoofditem → geen kapotte payload

    var main = { id: variantId, quantity: 1 };

    // Made-to-order: de keuzes reizen mee als line item properties (prijs zit in de Draagtijd-variant).
    if (selection.type === "mto" && selection.mto && typeof selection.mto === "object") {
      var props = {};
      if (selection.mto.verkoopster) props["Verkoopster"] = String(selection.mto.verkoopster);
      if (selection.mto.draagtijd) props["Draagtijd"] = String(selection.mto.draagtijd);
      if (selection.mto.kledingstuk) props["Kledingstuk"] = String(selection.mto.kledingstuk);
      if (Object.keys(props).length) main.properties = props;
    }

    var items = [main];

    var addons = Array.isArray(selection.addons) ? selection.addons : [];
    for (var i = 0; i < addons.length; i++) {
      var aid = toId(addons[i]);
      if (aid != null) items.push({ id: aid, quantity: 1 });   // ongeldige add-on's overslaan
    }

    return { items: items };
  }

  return { buildCartPayload: buildCartPayload };
});
